import {Form as AntForm} from 'antd';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import Form from '../../../../../components/Form/Form';
import MobileModalForm from '../../../../../components/Form/MobileModalForm';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import useIsMobileViewport from '../../../../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import log from '../../../../../services/logger/log';
import {makeSelectCurrentProfile} from '../../../../../state/selectors/deviceProfiles';
import helpers from '../../../../../utils/helpers';
import chirpStackProfileModalService from './chirpStackProfileModalService';

const ChirpStackProfileModal = (props) => {
    const {onOk, onCancel, modalType, initialData} = props;
    const [form] = AntForm.useForm();
    const isMobile = useIsMobileViewport();
    const strings = getLocalizedStrings();

    const profileFromStore = useSelector(makeSelectCurrentProfile());
    const data = initialData || profileFromStore;

    const modalData = chirpStackProfileModalService.getChirpStackProfileModalContent(modalType, data);
    const {formContent, title, submitButton, cancelButton, initialValues} = modalData || {};

    const onFinish = async () => {
        try {
            const values = await form.validateFields();

            values.profileId = data?.key;
            helpers.runFunction(onOk, values);
        } catch (error) {
            log.error(`ChirpStackProfileModal - validate failed: ${error}`);
        }
    };

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }
    }, [initialValues, form]);

    if (isMobile)
        return (
            <MobileModalForm
                form={form}
                formName='settings-chirpstackprofilemodal'
                title={title}
                closeLabel={strings[localizationKeys.SETTINGS_MOBILE_CLOSE_FORM]}
                onCancel={onCancel}
                onFinish={onFinish}
                formFields={formContent}
                submitButton={submitButton}
                cancelButton={cancelButton}
                initialValues={initialValues}
            />
        );

    return (
        <Form
            closeModal={onCancel}
            submitButton={submitButton}
            onFinish={onFinish}
            title={title}
            formFields={formContent}
            cancelButton={cancelButton}
            formInstance={form}
            initialValues={initialValues}
        />
    );
};

export default React.memo(ChirpStackProfileModal);
